module.exports = __webpack_public_path__ + "static/img/MX@3x.3f1ea890.png";